import React from 'react';
import {createRoot} from 'react-dom/client';

import App from './app';
import reportWebVitals from './reportWebVitals';
import './envPrint';

// React 18：必须使用 createRoot，ReactDOM.render 已被废弃并产生警告
const container = document.getElementById('root');
createRoot(container).render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
reportWebVitals();
